import React from 'react';
import { Modal as AntdModal } from 'antd';

const Modal = React.memo(({ ...rest }) => <AntdModal centered maskClosable={false} closable={false} {...rest} />);

export default Modal;
